import { ChangeDetectionStrategy, Component, HostBinding, inject, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';
import { OrganisationSettingsService, isDateInPast, isDateWithinUCUM } from 'shared/util-common';

import { Ucum } from '@treetop/shared/model';

import { IconDirective } from '../icon/icon.directive';
import { TooltipDirective } from '../tooltip/tooltip.directive';

@Component({
  selector: 'tt-revision-date-label',
  standalone: true,
  imports: [TranslocoPipe, IconDirective, MatIconModule, TooltipDirective, TranslocoDatePipe],
  templateUrl: './revision-date-label.component.html',
  styleUrl: './revision-date-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RevisionDateLabelComponent {
  private soonToExpirePeriod = (inject(OrganisationSettingsService).settings().revisionDateSettings?.soonToExpirePeriod as Ucum) ?? '3mo';

  protected _revisionDate: Date | Ucum;
  @Input() public set revisionDate(revisionDate: Date) {
    this._revisionDate = revisionDate;
    this.isExpired = isDateInPast(revisionDate);
    this.isExpiring = isDateWithinUCUM(revisionDate, this.soonToExpirePeriod);
  }

  @Input() public showLabel = true;

  @HostBinding('class.revision-date-label--expired')
  protected isExpired = false;

  @HostBinding('class.revision-date-label--expiring')
  protected isExpiring = false;

  @HostBinding('class.revision-date-label') hostCls = true;
}
